import cx from 'classnames'

import { useThemeContext } from 'theme/themeProvider'

import classes from './styles.module.scss'

type IconTypes = 'facebook' | 'twitter' | 'instagram' | 'tiktok' | 'youtube'

type Props = {
  type: IconTypes
  href: string
  onClick: () => void
  className?: string
}

export default function SocialButton(props: Props) {
  const { isDarkMode } = useThemeContext()
  const logoMode = isDarkMode ? 'white' : 'black'

  return (
    <a
      href={props.href}
      className={cx(classes.root, props?.className)}
      rel='noopener noreferrer'
      target='_blank'
      data-test={`social-button-${props.type}`}
      onClick={props.onClick}
    >
      {props.type !== 'twitter' ? (
        <img
          className={classes.image}
          src={`${process.env.IMG_ORIGIN}/logos/${props.type}_2024.png`}
          alt={props.type}
        />
      ) : (
        <img
          className={classes.image}
          src={`${process.env.IMG_ORIGIN}/logos/${props.type}_${logoMode}.png`}
          alt={props.type}
        />
      )}
    </a>
  )
}
